import { DebtRepaymentPlan, Div, Modal } from '@vgrubs/components';
import { RepaymentPlanHistory } from './RepaymentPlanHistory';

type Props = {
  isOpen: boolean;
  /** Stopped and completed plans, newest first. */
  plans: DebtRepaymentPlan[];
  onClose: () => void;
};

/**
 * The plans a location had before, behind the plan card's "Past plans" link,
 * the same way "Repayment history" opens its list: on the page they pushed
 * the location's own charges down.
 */
export const PastPlansModal = ({ isOpen, plans, onClose }: Props) => (
  <Modal
    isOpen={isOpen}
    closeModal={onClose}
    logo={false}
    width="1000px"
    header="Past plans"
    subtitle={`${plans.length} ${plans.length === 1 ? 'plan' : 'plans'}`}
  >
    {/* The modal centres its text; the plan rows read left-aligned, as on
        the page. */}
    <Div style={{ textAlign: 'left' }}>
      <RepaymentPlanHistory plans={plans} />
    </Div>
  </Modal>
);
